<template>
  <div class="mock-flinks">
    <div class="mock-flinks__title">
      <AppCheckbox
        theme="black"
        :value="showMockFields"
        :square="true"
        @input="handleCheckbox($event)"
      >
        Use Mock Banking server
      </AppCheckbox>
    </div>
    <div v-show="showMockFields">
      <AppInputWithValidation
        key="first_name"
        label="First Name"
        name="first_name"
        :value="firstName"
        type="text"
        :theme="theme"
        @input="handleInput('firstName', $event)"
      />
      <AppInputWithValidation
        key="last_name"
        label="Last Name"
        name="last_name"
        :value="lastName"
        type="text"
        :theme="theme"
        @input="handleInput('lastName', $event)"
      />

      <AppSelectWithValidation
        :items="['flinks', 'plaid']"
        :value="providerValue"
        @input="handleSelectInput"
      />

      <AppButton
        :theme="theme"
        :disabled="isLoading"
        @click="handleSubmit"
      >
        Continue
      </AppButton>
    </div>
  </div>
</template>

<script>
import Axios from '@/utilities/axios-instance'
import AppInputWithValidation from '@/components/common/inputs//AppInputWithValidation'
import AppCheckbox from '@/components/common/inputs//AppCheckbox'
import AppButton from '@/components/common/buttons/AppButton'
import theme from '@/mixins/theme'
import navigation from '@/mixins/navigation'
import submitLoans from '@/mixins/submit/submit-loans'
import AppSelectWithValidation from '../inputs/AppSelectWithValidation'

export default {
  // Name
  name: 'MockFlinks',

  components: {
    AppInputWithValidation,
    AppCheckbox,
    AppButton,
    AppSelectWithValidation
  },

  mixins: [
    theme,
    navigation,
    submitLoans
  ],

  data () {
    return {
      firstName: '',
      lastName: '',
      showMockFields: false,
      documentsUrl: process.env.VUE_APP_MOCK_FLINKS_URL,
      isLoading: false,
      providerValue: 'flinks'
    }
  },

  computed: {
    firstNameStored () {
      return this.$store.state.customer.first_name
    },

    lastNameStored () {
      return this.$store.state.customer.last_name
    },

    cduid () {
      return this.$store.state.application.cduid
    },

    flinksCallbackURL () {
      return process.env.VUE_APP_MOCK_FLINKS_CALLBACK
    },

    token () {
      return process.env.VUE_APP_API_TOKEN
    }
  },

  beforeMount () {
    this.firstName = this.firstNameStored
    this.lastName = this.lastNameStored
  },

  methods: {
    handleCheckbox (val) {
      this.showMockFields = val
    },

    handleInput (field, val) {
      if (field === 'firstName') {
        this.firstName = val
      } else if (field === 'lastName') {
        this.lastName = val
      }
    },

    handleSelectInput (val) {
      this.providerValue = val
    },

    async handleSubmit () {
      this.isLoading = true

      try {
        const data = {
          cduid: this.cduid,
          first_name: this.firstName,
          last_name: this.lastName,
          callback_url: this.flinksCallbackURL,
          vendor: this.providerValue,
          token: this.token
        }
        await Axios.post(this.documentsUrl, data)
        this.$_loans_submitLeadIfReady(false, false, this.datalayerComplete)
      } catch (error) {
        console.warn(error)
        alert('Oops! Something went wrong. Please check if Flinks mock service is working.')
      }
      this.isLoading = false
    }
  }
}
</script>

<style scoped lang="scss">
  .mock-flinks {
    @apply flex flex-col items-center container text-center border-pink-500 bg-pink-100 bg-opacity-10;
    @apply py-10 px-5 mb-15 border-1 border-pink-500 rounded-10;

    &__title {
      @apply flex flex-row justify-evenly mb-15;
    }

    &__label {
      @apply mr-15;
    }
  }
</style>
